import { useState, useEffect } from "react";
import {
  getTranscriptsByID,
  getTranscriptionFinal,
  uploadTranscriptionToS3,
} from "../../services/transcript.service";
import Button from "../button/button";

const ListTranscript = ({ id }) => {
  const [transcripts, setTranscripts] = useState([]);
  const [transcription, setTranscription] = useState([]);
  const [audioUrlGet, setAudioUrlGet] = useState("");

  const [totalTimeSpeakers, setTotalTimeSpeakers] = useState([]);

  const [editingIndex, setEditingIndex] = useState(null);
  const [editedTranscript, setEditedTranscript] = useState();

  const [speakers, setSpeakers] = useState([]);
  const [newTeacher, setNewTeacher] = useState("");

  const getAllTranscriptsByID = async () => {
    try {
      if (!id) return;
      const response = await getTranscriptsByID(id);
      setTranscripts(response);
      console.log("Transcripts:", response);
    } catch (err) {
      console.error("Error fetching transcripts:", err);
    }
  };

  useEffect(() => {
    getAllTranscriptsByID();
    // eslint-disable-next-line
  }, [id]);

  const formattedTranscripts = (transcript) => {
    // eslint-disable-next-line
    const match = transcript.match(/\/([^\/]+)-[^-]+/);
    return match ? match[1] : transcript;
  };

  const getFinalTranscription = async (audioUrl) => {
    try {
      const response = await getTranscriptionFinal(audioUrl);
      getTotalTimeBySpeaker(response.utterances);
      setTranscription(response.utterances);
      setAudioUrlGet(audioUrl);
      getSpeakers(response.utterances);
    } catch (err) {
      console.error("Error fetching transcription:", err);
    }
    setEditingIndex(null);
  };

  const getSpeakers = (utterances) => {
    const uniqueSpeakers = [
      ...new Set(utterances.map((utterance) => utterance.speaker)),
    ];

    const formattedSpeakers = uniqueSpeakers.map((speaker) => ({
      value: speaker,
      label: speaker,
    }));

    setSpeakers(formattedSpeakers);
  };

  const handleSpeakerChange = (event) => {
    setNewTeacher(event.target.value);
  };

  const updateUtterancesSpeaker = (transcriptionURL) => {
    if (!newTeacher) {
      alert("Por favor selecciona un docente.");
      return;
    }

    const updatedTranscription = transcription.map((utterance) => {
      if (utterance.speaker === "Docente") {
        return { ...utterance, speaker: newTeacher };
      } else if (utterance.speaker === newTeacher) {
        return { ...utterance, speaker: "Docente" };
      }
      return utterance;
    });

    setTranscription(updatedTranscription);
    getTotalTimeBySpeaker(updatedTranscription);
    setNewTeacher("");

    const newTranscript = {
      utterances: updatedTranscription,
    };

    uploadTranscriptionToS3(transcriptionURL, newTranscript);
    
  };

  const startEditing = (index) => {
    setEditingIndex(index);
    setEditedTranscript(transcription[index].text);
  };

  const handleEditedTranscriptChange = (event) => {
    setEditedTranscript(event.target.value);
  };

  const saveEditedTranscript = (transcriptionURL) => {
    if (editingIndex !== null) {
      const updatedTranscription = [...transcription];
      updatedTranscription[editingIndex] = {
        ...updatedTranscription[editingIndex],
        text: editedTranscript,
      };

      const newTranscript = {
        utterances: updatedTranscription,
      };

      console.log("New Transcript:", newTranscript);

      setTranscription(newTranscript.utterances);

      uploadTranscriptionToS3(transcriptionURL, newTranscript);

      setEditingIndex(null);
      setEditedTranscript("");
    }
  };

  const formatTime = (milliseconds) => {
    const totalSeconds = Math.floor(milliseconds / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;

    return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(
      2,
      "0"
    )}`;
  };

  const getTotalTimeBySpeaker = (utterances) => {
    const time = {};

    utterances.forEach((utterance) => {
      const speaker = utterance.speaker;
      const duration = utterance.end_time - utterance.start_time;
      if (!time[speaker]) {
        time[speaker] = 0;
      }
      time[speaker] += duration;
    });

    const timeBySpeaker = Object.keys(time).map((speaker) => ({
      speaker: speaker,
      totalDuration: time[speaker],
    }));

    setTotalTimeSpeakers(timeBySpeaker);
  };

  return (
    <div className="w-full">
      <div className="flex justify-center w-full mb-4">
        <h3 className="text-white">Lista de Transcripciones</h3>
      </div>
      <div className="flex w-full gap-3">
        <div className="w-[30%] max-h-[80vh] overflow-y-auto">
          {transcripts.map((transcript) => (
            <div
              key={transcript}
              className="bg-gray-800 text-white p-4 mb-2 rounded-lg shadow-lg border-2 border-white cursor-pointer"
              onClick={() => getFinalTranscription(transcript)}
            >
              <p>{formattedTranscripts(transcript)}</p>
            </div>
          ))}
        </div>

        <div className="w-[70%] max-h-[80vh] overflow-y-auto border-2 border-white ml-4 rounded-xl">
          <div className="text-white flex justify-between px-8 mt-8">
            {totalTimeSpeakers.map((speaker, index) => (
              <div
                key={index + "total-time"}
                className="text-center border border-solid border-white p-4 rounded-2x"
              >
                <p className="m-0">
                  <span className="font-bold">Speaker: </span>
                  {speaker.speaker}
                </p>
                <p className="mb-3">
                  <span className="font-bold">Tiempo intervenido: </span>
                  {formatTime(speaker.totalDuration)}
                </p>
              </div>
            ))}
          </div>
          {audioUrlGet && (
          <div className="text-white flex flex-col justify-center items-center px-8 mt-8 text-center">
            <p>Cambiar Docente:</p>
            <select
              className="border rounded p-2 mt-2 w-[50%]"
              value={newTeacher}
              onChange={handleSpeakerChange}
            >
              <option value="" disabled>
                Selecciona un docente
              </option>
              {speakers.map((speaker) => (
                <option key={speaker.value} value={speaker.value}>
                  {speaker.label}
                </option>
              ))}
            </select>
            <Button
              label={"Cambiar"}
              variant={"primary"}
              customClassName="mt-8"
              onClick={() => updateUtterancesSpeaker(audioUrlGet)}
            />
          </div>
          )}

          {transcription.map((transcript, index) => (
            <div
              className="mt-5 flex justify-between items-start"
              key={index + "t"}
            >
              <div className="flex items-start w-full">
                {editingIndex === index ? (
                  <div className="w-full">
                    <div className="text-white flex gap-4 px-8 mb-[-15px]">
                      <p>
                        <span className="font-bold">Persona: </span>
                        {transcript.speaker}
                      </p>
                      <p>
                        <span className="font-bold">Tiempo: </span>
                        {formatTime(transcript.start_time)} -{" "}
                        {formatTime(transcript.end_time)}
                      </p>
                    </div>
                    <textarea
                      value={editedTranscript}
                      onChange={handleEditedTranscriptChange}
                      className="bg-transparent text-white p-4 rounded-lg w-[95%] border border-transparent border-white mx-8"
                    />
                  </div>
                ) : (
                  <div>
                    <div className="text-white flex gap-4 px-8 mb-[-15px]">
                      <p>
                        <span className="font-bold">Persona: </span>
                        {transcript.speaker}
                      </p>
                      <p>
                        <span className="font-bold">Tiempo: </span>
                        {formatTime(transcript.start_time)} -{" "}
                        {formatTime(transcript.end_time)}
                      </p>
                    </div>
                    <p className="text-white px-8 text-lg" key={index}>
                      {transcript.text}
                    </p>
                  </div>
                )}
              </div>

              <div className="flex items-start">
                {editingIndex === index ? (
                  <Button
                    onClick={() => saveEditedTranscript(audioUrlGet)}
                    label={"Guardar"}
                    variant={"primary"}
                    customClassName="mr-5"
                    key={"edit " + index}
                  />
                ) : (
                  <Button
                    onClick={() => startEditing(index)}
                    label={"Editar"}
                    variant={"primary"}
                    customClassName="mr-5"
                    key={"save " + index}
                  />
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ListTranscript;
